"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMessage = exports.refresh = exports.get = void 0;
var _webMessageSchemas = require("@kiwicom/web-message-schemas");
var utils = _interopRequireWildcard(require("./utils"));
var _utils2 = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const timeout = 1000;
const sendMessage = async forceRefresh => {
  try {
    (0, _utils2.log)("REFRESH-TOKEN POST-MESSAGE start");
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => {
        reject(new Error("Timeout waiting for mobile app response"));
      }, timeout);
    });
    const messagePromise = (0, _webMessageSchemas.postMessageToMobileApp)({
      message: "provideAccessToken",
      messagePayload: {
        forceRefresh
      },
      response: {
        accessToken: ""
      }
    });
    const response = await Promise.race([messagePromise, timeoutPromise]);
    (0, _utils2.log)("REFRESH-TOKEN POST-MESSAGE have response", response);
    if (typeof response.accessToken === "string") {
      return utils.processTokens(response.accessToken, null);
    }
    return utils.emptyTokenData();
  } catch (error) {
    (0, _utils2.log)("REFRESH-TOKEN POST-MESSAGE failed to provide access token:", error);
    return utils.emptyTokenData();
  }
};
exports.sendMessage = sendMessage;
const get = () => {
  return sendMessage(false);
};
exports.get = get;
const refresh = () => {
  return sendMessage(true);
};
exports.refresh = refresh;